// Minimal markdown renderer for AI reading material (headings, lists, bold/italic/code, [n] citations).
const inline = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(?<!\*)\*(?!\*)([^*]+)\*(?!\*)/g, "<em>$1</em>")
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(/\[(\d+)\]/g, '<a href="#src-$1" class="cite">[$1]</a>');

export const Markdown = ({ text = "" }) => {
  const blocks = [];
  let list = null;
  let fence = null;

  const flush = () => {
    if (list) {
      blocks.push({ type: list.ordered ? "ol" : "ul", items: list.items });
      list = null;
    }
  };

  text.split("\n").forEach((raw) => {
    const line = raw.trimEnd();
    if (line.trim().startsWith("```")) {
      if (fence) {
        blocks.push({ type: "pre", text: fence.join("\n") });
        fence = null;
      } else {
        flush();
        fence = [];
      }
      return;
    }
    if (fence) {
      fence.push(raw);
      return;
    }
    if (!line.trim()) return flush();
    const h = line.match(/^(#{1,4})\s+(.*)$/);
    if (h) {
      flush();
      blocks.push({ type: `h${Math.min(h[1].length + 1, 4)}`, text: h[2] });
      return;
    }
    const ul = line.match(/^\s*[-*+]\s+(.*)$/);
    const ol = line.match(/^\s*\d+\.\s+(.*)$/);
    if (ul || ol) {
      const item = (ul || ol)[1];
      if (!list || list.ordered !== Boolean(ol)) {
        flush();
        list = { ordered: Boolean(ol), items: [] };
      }
      list.items.push(item);
      return;
    }
    flush();
    blocks.push({ type: "p", text: line });
  });
  flush();
  if (fence) blocks.push({ type: "pre", text: fence.join("\n") });

  return (
    <div className="prose-read" data-testid="reader-material">
      {blocks.map((b, i) => {
        if (b.type === "pre") {
          return (
            <pre key={i} className="my-4 p-4 rounded-xl bg-slate-900 text-slate-100 text-sm overflow-x-auto font-mono-x">
              {b.text}
            </pre>
          );
        }
        if (b.type === "ul" || b.type === "ol") {
          const Tag = b.type;
          return (
            <Tag key={i}>
              {b.items.map((item, j) => (
                <li key={j} dangerouslySetInnerHTML={{ __html: inline(item) }} />
              ))}
            </Tag>
          );
        }
        const Tag = b.type;
        return <Tag key={i} dangerouslySetInnerHTML={{ __html: inline(b.text) }} />;
      })}
    </div>
  );
};
